module.exports = __webpack_public_path__ + "static/media/users-cog.c71cc3ee.svg";